<div class="h-screen w-full overflow-hidden flex"> <!-- p-2 -->

  <div class="flex h-full w-full bg-white dark:bg-indigo-custom overflow-hidden"> <!-- rounded-xl -->

    <!-- DESKTOP SIDEBAR -->
    <div *ngIf="isDesktop"
         class="bg-white dark:bg-indigo-custom rounded-tl-xl rounded-bl-xl z-20 h-full transition-[width,transform] duration-300 ease-in-out"
         [ngStyle]="{'width': sidebarCollapsed ? '5rem' : '18rem'}">
      <app-sidebar
        [layout]="'main'"
        [collapsed]="sidebarCollapsed"
        (collapsedChange)="onSidebarCollapsedChange($event)"
        class="w-full h-full">
      </app-sidebar>
    </div>

    <!-- MOBILE SIDEBAR OVERLAY (only appears when mobile sidebar is toggled) -->
    <div *ngIf="!isDesktop && showMobileSidebar"
         class="fixed inset-0 bg-secondary-900 bg-opacity-50 backdrop-blur-sm z-30 transition-opacity duration-300"
         (click)="toggleMobileSidebar()">
    </div>

    <!-- MOBILE SIDEBAR -->
    <div *ngIf="!isDesktop"
         class="fixed left-0 top-0 bottom-0 w-[18rem] bg-white rounded-tr-xl rounded-br-xl z-40 transition-transform duration-300 ease-in-out transform-gpu"
         [ngClass]="{'translate-x-0': showMobileSidebar, '-translate-x-full': !showMobileSidebar}">
      <app-sidebar
        [layout]="'main'"
        [collapsed]="false"
        (collapsedChange)="onSidebarCollapsedChange($event)"
        (closeMobile)="toggleMobileSidebar()"
        class="w-full h-full">
      </app-sidebar>
    </div>

    <!-- Main content area -->
    <div class="flex flex-col flex-1 bg-white dark:bg-indigo-custom overflow-hidden rounded-tr-xl rounded-br-xl transition-[margin,width] duration-300 ease-in-out">

      <!-- Header area with mobile menu button - conditionally visible -->
      <div *ngIf="showHeader" class="flex justify-between items-center bg-gray-50 dark:bg-secondary-800 rounded-xl px-6 py-3 h-20 p-6 m-3 lg:m-6 lg:mb-0">

        <!-- Mobile menu button - only shown on mobile -->
        <button type="button"
                *ngIf="!isDesktop"
                class="inline-flex items-center justify-center p-2 rounded-md text-secondary focus:outline-none"
                (click)="toggleMobileSidebar()"
                aria-label="Open sidebar menu">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <div>
          <h1 class="text-lg font-semibold text-secondary dark:text-primary-100 leading-tight">{{ pageTitle }}</h1>
          <span *ngIf="pageDescription" class="text-xs text-secondary/75 dark:text-primary-100 leading-none hidden lg:block mt-1">{{ pageDescription }}</span>
        </div>

        <!-- Dark Mode Toggle -->
        <app-dark-mode-toggle [mode]="'dashboard'" class="rotate-90 relative left-[0.5rem]"></app-dark-mode-toggle>

      </div>

      <!-- Content area with router-outlet -->
      <div class="flex-1 overflow-auto custom-scroll" [ngClass]="{'mt-0': !showHeader, 'mt-auto': showHeader}">

        <router-outlet></router-outlet>

      </div>

    </div>

  </div>

</div>

<app-subscription-banner></app-subscription-banner>
